import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    CardDescription,
} from "@shared-frontend/components/ui/card";
import { Button } from "@shared-frontend/components/ui/button";
import { CheckCircle } from "lucide-react";

export function PasswordSetSuccessPage() {
    const navigate = useNavigate();

    // Auto-redirect after 5 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/login");
        }, 5000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-background">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <CheckCircle className="h-16 w-16 text-green-600 mx-auto mb-4" />
                    <CardTitle className="text-2xl">
                        Password Set Successfully!
                    </CardTitle>
                    <CardDescription>
                        Your account has been verified and your password has
                        been set. You can now log in to HelmGuard.
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="text-center text-sm text-muted-foreground">
                        You will be redirected to the login page in 5 seconds...
                    </div>
                    <Button
                        onClick={() => navigate("/login")}
                        className="w-full"
                    >
                        Go to Login
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
}
